import { Link } from 'react-router-dom';
import { SeoPage } from './SeoLayout';
import { getLocalBusinessSchema, getBreadcrumbSchema } from '../../data/businessInfo';
import { BookOpen, ArrowRight } from 'lucide-react';

export const RATGEBER = [
  {
    slug: 'wohnungsuebergabe',
    title: 'Wohnung streichen vor der Übergabe',
    excerpt: 'Was der Vermieter fordern darf, was Sie selbst machen können — und wann sich der Malerbetrieb wirklich lohnt.',
    minutes: 6
  },
  {
    slug: 'tapete-entfernen',
    title: 'Tapete entfernen: Anleitung & Kostenüberblick',
    excerpt: 'Alte Tapete lösen, Untergrund vorbereiten, häufige Fehler vermeiden — praktisch für DIY und Malerbetrieb-Vergleich.',
    minutes: 5
  },
  {
    slug: 'wandfarbe-auswaehlen',
    title: 'Welche Wandfarbe für welchen Raum?',
    excerpt: 'Farbwirkung, Deckkraft, Wischbeständigkeit, Aufwand — wie Sie die richtige Farbe für Wohnzimmer, Küche, Bad und Kinderzimmer finden.',
    minutes: 7
  }
];

export default function RatgeberHub() {
  return (
    <SeoPage
      title="Malerarbeiten Ratgeber | Tipps von FarbWelt Maler Express Service Dormagen"
      description="Praktische Ratgeber zum Streichen, Tapezieren und Renovieren — von der Wohnungsübergabe bis zur richtigen Wandfarbe. Ehrlich und ohne Werbe-Blabla erklärt."
      canonicalPath="/ratgeber"
      kicker="Ratgeber"
      heroTitle="Praktische Tipps rund ums Streichen, Tapezieren und Renovieren"
      heroSubtitle="Ehrliche Anleitungen ohne Werbe-Blabla — geschrieben von Handwerkern, die täglich in Kundenwohnungen arbeiten."
      jsonLd={[
        getLocalBusinessSchema(),
        getBreadcrumbSchema([
          { name: 'Startseite', item: '/' },
          { name: 'Ratgeber', item: '/ratgeber' }
        ])
      ]}
    >
      <div className="not-prose grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {RATGEBER.map(r => (
          <Link
            key={r.slug}
            to={`/ratgeber/${r.slug}`}
            className="group block p-6 bg-white border border-gray-200 rounded-xl hover:border-[#9B1B30] hover:shadow-lg transition-all"
          >
            <div className="w-10 h-10 rounded-lg bg-[#9B1B30]/10 flex items-center justify-center mb-4">
              <BookOpen className="w-5 h-5 text-[#9B1B30]" />
            </div>
            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">{r.minutes} Min. Lesezeit</div>
            <h2 className="text-lg font-bold text-[#1A1A1A] mb-2 mt-0 group-hover:text-[#9B1B30] transition-colors">
              {r.title}
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">{r.excerpt}</p>
            <span className="text-[#9B1B30] text-sm font-semibold inline-flex items-center gap-1">
              Ratgeber lesen <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>

      <h2 className="mt-12">Warum ein Ratgeber vom Malerbetrieb?</h2>
      <p>
        Weil wir jeden Tag sehen, was auf Baustellen tatsächlich passiert — nicht was in
        Herstellerprospekten steht. In diesen Ratgebern schreiben wir auf, was wir bei Kunden
        in Dormagen und Umgebung immer wieder erklären: Wann sich ein Anstrich selbst lohnt,
        wann Sie besser einen Fachmann rufen, und wo die typischen Fehler passieren.
      </p>
      <p>
        Wenn Sie konkrete Fragen zu Ihrem Projekt haben, rufen Sie uns einfach an — wir beraten
        Sie kostenlos, auch wenn Sie am Ende doch selbst zum Pinsel greifen.
      </p>
    </SeoPage>
  );
}
